import { render, staticRenderFns } from "./StepMessage.vue?vue&type=template&id=aa3d5676&scoped=true"
import script from "./StepMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepMessage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StepMessage.vue?vue&type=style&index=0&id=aa3d5676&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3d5676",
  null
  
)

export default component.exports